<template>
  <ul v-if="links.length">
    <li
      v-for="({ link }, index) in links"
      :key="`links_${id}_${index}`"
    >
      <app-link
        :link="link"
        class="link link--naked"
      />
    </li>
  </ul>
</template>

<script setup>
import { defineAsyncComponent, useId } from 'vue'
import { useStyle } from '@/composables/app/useStyle'

const AppLink = defineAsyncComponent(() => import('&/atoms/AppLink'))

const { parent, component } = defineProps({
  parent: { type: Object, required: true },
  component: { type: Object, required: true }
})

const id = useId()
const { componentStyle: parentStyle } = useStyle(parent.style)
const { componentStyle: blockStyle } = useStyle(component.style)

const { links = [] } = component.attributes
const color = blockStyle.value.color || parentStyle.value.color
</script>

<style lang="scss" scoped>
:deep(.link) {
  position: relative;
  color: v-bind(color);

  &:after {
    content: '';
    position: absolute;
    width: 100%;
    height: 1px;
    background-color: v-bind(color);
    bottom: 0;
    left: 0;
    transform-origin: right;
    transform: scaleX(0);
    transition: transform .3s ease-in-out;
  }

  &:hover:after {
    transform-origin: left;
    transform: scaleX(1);
  }

  &.is-active:after, &.is-active:hover:after {
    transform: scaleX(1);
  }
}
</style>
